<template>
  <v-layout justify-end>
    <v-btn outline slot="activator" color="primary" class="mb-2" @click="open">
      <v-icon dark left>note_add</v-icon>New Item
    </v-btn>
    <v-dialog v-model="localDialog" persistent max-width="500px" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container fluid>
            <v-layout align-space-around justify-center column>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field
                  label="Name"
                  v-model="local.name"
                  :rules="generalRules"
                  required>
                </v-text-field>
                <v-text-field
                  label="Service"
                  v-model="local.service">
                </v-text-field>
                <v-textarea
                  label="Description"
                  v-model="local.description">
                </v-textarea>
                <audio-uploader
                  @input="assignAudio"
                  v-model="local.audio">
                  <div slot="activator">
                    <v-text-field
                      label="Upload Audio"
                      v-model='local.audio.audioName'
                      disabled prepend-icon='attach_file'
                      :rules="generalRules"
                      required>
                    </v-text-field>
                  </div>
                </audio-uploader>
                <div v-if="local.audio">
                  <div v-if="local.audio.audioURL">
                    <vuetify-audio :file=local.audio.audioURL>
                    </vuetify-audio>
                  </div>
                </div>
                <v-text-field
                  v-model="local.duration"
                  v-bind:errorMsg="errorMsg"
                  label="Duration (sec)"
                  type="number" :rules="generalRules"
                  required>
                </v-text-field>
                <v-text-field
                  v-model="local.spatialBlend"
                  label="Spatial Blend"
                  type="number" :rules="generalRules"
                  required>
                </v-text-field>
                <v-select
                  :items="soundTypes"
                  v-model="local.soundType"
                  label="Select Sound Type"
                  :rules="generalRules"
                  required
                  chips
                  persistent-hint>
                </v-select>
                <!-- <h3>Type of Component</h3>
                  <v-radio-group v-model="local.componentType" row>
                    <v-radio :label="componentType.character" :value="componentType.character"></v-radio>
                    <v-radio :label="componentType.threeD" :value="componentType.threeD"></v-radio>
                  </v-radio-group> -->
              </v-form>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outline @click="close">Cancel</v-btn>
          <v-btn color="primary" v-if="showSaveButton" @click="save">
            <v-flex v-if="this.saving">
              <v-progress-circular
                indeterminate
                color="primary">
              </v-progress-circular>
            </v-flex>
            <v-flex v-else>Save</v-flex>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import VuetifyAudio from 'vuetify-audio'
import AudioUploader from '../uploader/audioUploader'

export default {
  name: 'addSound',
  components: { AudioUploader, VuetifyAudio },
  data: () => ({
    file: 'http://www.noiseaddicts.com/samples_1w72b820/290.mp3',
    errorMsg: '',
    valid: true,
    generalRules: [
      v => !!v || 'This field is required'
    ],
    soundType: [],
    saving: false,
    local: {
      id: null,
      name: '',
      audio: {
        audioName: '',
        audioFile: '',
        audioURL: ''
      },
      service: '',
      description: '',
      soundType: '',
      duration: 0,
      spatialBlend: 0
    },
    soundTypes: ['2D', '3D']
  }),
  props: {
    dialog: '',
    editedID: '',
    showSaveButton: true,
    info: {
      id: null,
      name: '',
      filename: '',
      audio: {
        audioName: '',
        audioFile: '',
        audioURL: ''
      },
      service: ''
    }
  },
  computed: {
    formTitle () {
      return this.editedID === -1 ? 'New Sound' : this.showSaveButton ? 'Edit Sound' : 'Preview Sound'
    },
    localDialog: {
      get: function () {
        return this.dialog
      }
    }
  },
  watch: {
    info (val) {
      this.local = Object.assign({}, val)
    },
    dialog (val) {
      if (!val) {
        this.saving = false
      }
    }
  },
  methods: {
    assignAudio (payload) {
      this.local.audio = payload
    },
    open () {
      this.$emit('open')
    },
    close () {
      this.$emit('close')
    },
    validateForm () {
      let flag = this.$refs.form.validate()
      if (this.local.duration === 0) {
        flag = false
        this.errorMsg = 'Duration should be greater than zero'
      }
      return flag
    },
    save () {
      if (this.validateForm()) {
        this.saving = true
        this.$emit('save', this.local)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/assets/add-new/addSound.vue